// extracted by mini-css-extract-plugin
export default {"dpaForm":"DPAForm_dpaForm__V6LTQ","logo":"DPAForm_logo__gbDGt","buttons":"DPAForm_buttons__IkjLc","group":"DPAForm_group__qSkRp","antCol":"DPAForm_antCol__pd2pu"};